/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInstrumentLinkRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetInstrumentLink.pb'
import {GetInstrumentLinkResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/GetInstrumentLink.pb'


export const getInstrumentLink = (request: GetInstrumentLinkRequest, options?: CashRequestOptions) => post<GetInstrumentLinkRequest, GetInstrumentLinkResponse>("/2.0/cash/get-instrument-link", request, {...options, rejectOnError: true })